module.exports = __webpack_public_path__ + "media/images/ad-logo-bb05e4e44a8778ef0917077dfe2fbf24.svg";